<template>
  <div class="text-center">
    <v-dialog persistent v-model="updateDialog" width="500">
      <v-card>
        <v-card-title
          class="d-flex justify-space-between headline purple accent-4 py-1"
        >
          <div class="subtitle-1 white--text">
            Update Form
          </div>
          <div>
            <v-btn @click="closeUpdateDialog" class="white--text" icon>
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pt-4">
          <label>Name</label>
          <v-text-field
            v-model.trim="eachBasicData.name"
            :error-messages="nameErrors"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-5 py-2">
          <v-spacer></v-spacer>
          <v-btn @click="updateBasicData" class="form-btn">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";

export default {
  mixins: [ValidationMixin],
  props: {
    eachBasicData: {
      type: Object,
      default: () => {
        return {
          name: null,
          type: null,
        };
      },
    },
    updateDialog: {
      type: Boolean,
    },
  },
  data: () => ({}),
  validations: {
    eachBasicData: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    nameErrors() {
      return this.handleFieldErrors(this.$v.eachBasicData.name);
    },
  },
  methods: {
    closeUpdateDialog() {
      this.$emit("closeUpdateDialog");
    },
    updateBasicData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          id: this.eachBasicData.id,
          name: this.eachBasicData.name,
          type: this.eachBasicData.type,
        };

        this.$store.dispatch("InitialData/update", data);

        this.eachBasicData.name = null;
        this.$v.$reset();
        this.closeUpdateDialog();
      }
    },
  },
};
</script>

<style scoped></style>
